import DepartmentDTO from '@src/adapters/dto/department/DepartmentDTO';
import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  department: DepartmentDTO;
}

interface Result {
  department: DepartmentDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/department',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveDepartmentLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveDepartmentLazy;
